// extracted by mini-css-extract-plugin
export default {"cls1":"BackButton-cls1__di","cls2":"BackButton-cls2_n35 BackButton-cls1__di"};